module.exports = __webpack_public_path__ + "img/img_14.62d79cbf.png";